// Tables
export const FIRESTORE_ORDERS_TABLE = "orders";
export const FIRESTORE_PRODUCTS_TABLE = "products";
export const FIRESTORE_PROMOTIONS_TABLE = "promotions";
export const FIRESTORE_USERS_TABLE = "users";
export const FIRESTORE_USER_FEEDBACK_TABLE = "userFeedback";
export const FIRESTORE_INVITED_USERS_TABLE = "invitedUsers";
export const FIRESTORE_DISCOUNT_CODES_TABLE = "discountCodes";
export const FIRESTORE_FEATURED_PRODUCTS_TABLE = "featuredProducts";
export const FIRESTORE_BANNERS_TABLE = "banners";
export const FIRESTORE_RECIPES_TABLE = "recipes";
export const FIRESTORE_CATEGORIES_TABLE = "categories";
export const FIRESTORE_LOYALTY_USERS_TABLE = "loyaltyUsers";
export const FIRESTORE_LOYALTY_CLAIMS_TABLE = "loyaltyClaims";
export const FIRESTORE_LOYALTY_REWARDS_TABLE = "loyaltyRewards";
export const FIRESTORE_BLOGPOSTS_TABLE = "blogPosts";
export const FIRESTORE_VACANCY_APPLICATIONS_TABLE = "vacancyApplications";
export const FIRESTORE_ANALYSIS_RFM_TABLE = "analysisRfm";
export const FIRESTORE_CAMPAIGNS_TABLE = "campaigns";
export const FIRESTORE_CAMPAIGN_SENDS_TABLE = "campaignSends";
export const FIRESTORE_PERSONAL_DISCOUNTS_TABLE = "personalDiscounts";
export const FIRESTORE_UTMS_TABLE = "utms";
export const FIRESTORE_USER_ANALYTICS_TABLE = "userAnalytics";
export const FIRESTORE_CUSTOMER_SEGMENTS_TABLE = "customerSegments";
export const FIRESTORE_NOTIFICATIONS_TABLE = "notifications";
export const FIRESTORE_STORE_SCHEDULE_TABLE = "storeSchedule";
export const FIRESTORE_ORDER_CAPACITY_TABLE = "orderCapacity";
export const FIRESTORE_PICK_ROUTE_TABLE = "pickRoute";
export const FIRESTORE_SUPPLEMENTS_SUBCOLLECTION = "supplements";
export const FIRESTORE_HISTORY_SUBCOLLECTION = "history";

// Variables
export const FIRESTORE_PRODUCT_VARIATIONS_PRICE = "price";
export const FIRESTORE_DEFAULT_ORDERS_MAX_DAYS = 30;
